import { render, staticRenderFns } from "./Ocean.vue?vue&type=template&id=6c79ce9b&scoped=true&"
import script from "./Ocean.vue?vue&type=script&lang=ts&"
export * from "./Ocean.vue?vue&type=script&lang=ts&"
import style0 from "./Ocean.vue?vue&type=style&index=0&id=6c79ce9b&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c79ce9b",
  null
  
)

export default component.exports